import { StyleSheet, View } from 'react-native';
import { Icon, Text, theme } from '@socrait/react';

export function FlashBanner({ message }: { message: { message: string; type: 'warning' | 'success' } }) {
  const backgroundColor = message.type === 'warning' ? theme.colors.red : theme.colors.green;

  return (
    <View style={[styles.messageContainer, { backgroundColor }]}>
      <Icon type={message.type === 'warning' ? 'error' : 'checkmark'} fill={theme.colors.white} />
      <Text style={styles.messageText}>{message.message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  messageContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing.xlarge,
    gap: theme.spacing.small,
  },
  messageText: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.small,
  },
});
